import { render, staticRenderFns } from "./TeacherRatingStudent.vue?vue&type=template&id=04b19e37&"
import script from "./TeacherRatingStudent.vue?vue&type=script&lang=js&"
export * from "./TeacherRatingStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports